export default __webpack_public_path__ + "static/media/goshen104.79d24b25.jpg";